import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import './styles/modal_record_series.scss';

const ModalRecordSeries = (props) => {
    const defaultContent = 'Selecciona como quieres grabar este contenido';
    let buttons = [
        {
            content: Translator.get('npvr_recording_modal_toRecord_option_serie', 'Serie completa'),
            props: {
                onClick: (e) => {
                    props &&
                        props.onRecordSerie &&
                        typeof props.onRecordSerie === 'function' &&
                        props.onRecordSerie();
                        props && props.handleClose && typeof props.handleClose === 'function' && props.handleClose();
                },
            },
        },
        {
            content: Translator.get('npvr_recording_modal_toRecord_option_episode', 'Episodio'),
            props: {
                onClick: (e) => {
                    props &&
                        props.onRecordEpisode &&
                        typeof props.onRecordEpisode === 'function' &&
                        props.onRecordEpisode();
                    props && props.handleClose && typeof props.handleClose === 'function' && props.handleClose();
                },
            },
        },
        {
            content: Translator.get('btn_modal_record_cancel', 'Cancelar'),
            extraClass: 'btn_modal_record_cancel',
            props: {
                onClick: (e) => {
                    props &&
                        props.handleClose &&
                        typeof props.handleClose === 'function' &&
                        props.handleClose();
                },
            },
        },
    ];

    if (props.buttons) {
        buttons = props.buttons;
    }

    const p = {
        content: Translator.get('npvr_recording_modal_toRecord_title', defaultContent),
        buttonsAlign: 'vertical',
        buttons: buttons,
    };

    return <ModalWrapper {...p} />;
};

export default withOnClose(ModalRecordSeries);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalRecordSeries.jsx